var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-wrapper"},[[_c('user-header')],_c('div',{staticClass:"application-content d-flex justify-content-between flex-column"},[_c('router-view'),_c('app-footer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }